import { TICKET_VIEW_MODE, TICKET_VIEW_MODES } from '@/config/ticket.config.js'

/** Presentation mode — keep key distinct from planned slice tab `?view=archived`. */
const KEY = 'layout'
const DEFAULT = TICKET_VIEW_MODE.LIST

function read(query = {}) {
  const value = query[KEY]
  if (typeof value === 'string' && TICKET_VIEW_MODES.includes(value)) return value
  return DEFAULT
}

/**
 * Missing / empty `layout` means list (valid — keep URL clean).
 * Only rewrite when the value is present but invalid.
 */
function hasTab(query = {}) {
  if (!Object.prototype.hasOwnProperty.call(query, KEY)) return true
  const value = query[KEY]
  if (value === '' || value == null) return true
  return typeof value === 'string' && TICKET_VIEW_MODES.includes(value)
}

function withTab(query = {}, active = DEFAULT) {
  const next = { ...query }
  if (active === DEFAULT) {
    delete next[KEY]
    return next
  }
  next[KEY] = active
  return next
}

class ManagementViewModeUtility {
  KEY = KEY
  DEFAULT = DEFAULT
  MODES = TICKET_VIEW_MODES

  read(query) {
    return read(query)
  }

  hasTab(query) {
    return hasTab(query)
  }

  withTab(query, active) {
    return withTab(query, active)
  }
}

export default new ManagementViewModeUtility()
